import { useMemo, useState } from 'react';
import { useGameStore } from '../store/gameStore';

const CONTINENTS = ['America', 'Europe', 'Africa', 'Asia', 'Oceania'] as const;
type ContinentName = typeof CONTINENTS[number];

export function ContinentPanel() {
    const [visible, setVisible] = useState(false);
    const guessedCountries = useGameStore((s) => s.guessedCountries);

    const byContinent = useMemo(() => {
        const groups = new Map<ContinentName, string[]>(CONTINENTS.map(c => [c, []]));
        for (const country of guessedCountries) {
            groups.get(country.continent as ContinentName)?.push(country.name);
        }
        return groups;
    }, [guessedCountries]);

    return (
        <div
            id="continent-panel-container"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            <button id="continent-toggle">🌍</button>
            {visible && (
                <div id="continent-panel">
                    <h3>Countries by Continent</h3>
                    <div id="continent-columns">
                        {CONTINENTS.map(continent => (
                            <div key={continent} className="continent-column">
                                <h4 className="continent-heading">{continent}</h4>
                                <ul className="continent-list">
                                    {byContinent.get(continent)!.map(name => (
                                        <li key={name} className="continent-country">{name}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
